import { MarketingResource } from "creso-core/types";
import { useState } from "react";
import { Badge } from "web-design-system";
import {
  getVideoPreviewImage,
  getYoutubeEmbedUrl,
  isResourceNew,
  getResourceLink,
} from "creso-core/utils";
import { VideoThumbnail } from "./video-thumbnail";
import VideoDialog from "./video-dialog";

const VideoCard = ({
  item,
  content,
}: {
  item: MarketingResource;
  content: React.ReactNode;
  imgClassName?: string;
}) => {
  const [open, setOpen] = useState(false);
  const link = getResourceLink(item);
  const thumbnail = getVideoPreviewImage(item);
  const embedUrl = getYoutubeEmbedUrl(link);
  const isNew = isResourceNew(item);

  if (!embedUrl) {
    return null;
  }

  return (
    <>
      <div
        className="relative flex flex-col overflow-hidden rounded-xl border border-border/60 bg-background h-full cursor-pointer p-2 gap-2"
        onClick={() => setOpen(true)}
      >
        {isNew ? (
          <Badge
            variant="custom"
            className="absolute top-5 left-5 z-10 rounded-sm px-1.5 py-0.5 bg-tag-orange-foreground text-tag-orange text-xxs"
          >
            NEW
          </Badge>
        ) : null}
        <VideoThumbnail
          title={item.title}
          src={thumbnail ?? ""}
          duration={item.metadata?.duration ?? ""}
        />
        {content}
      </div>
      <VideoDialog
        open={open}
        setOpen={setOpen}
        embedUrl={embedUrl ?? ""}
        title={item.title}
      />
    </>
  );
};

export default VideoCard;
